import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import { APPLY_BUTTON_VARIANT, CANCEL_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import {
  useGetStateByCountryIdQuery,
} from "@/services/countryState/countryStateReducer";
import {
  MotifButton,
  MotifFormField,
  MotifLabel,
  MotifInput,
  MotifSelect,
  MotifOption,
} from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

type BasicSearchPayloadType = {
  creditorName: string | undefined,
  creditorId: string | undefined,
  claimId: string | undefined,
  debtorName : string | undefined,
  country: string | undefined,
  province: string | undefined,
  postalCode: string | undefined,
  phoneNumber: string | undefined,
  claimUpdateDate: string | undefined,
  }

export const BasicSearch = ({
  handleChange,
  setShowBasicSearch,
  handleSubmit,
  basicSearchPayload,
  showBasicSearch,
}: any) => {
  const {t}=useTranslation();

  const [state, setState]  = useState<BasicSearchPayloadType>({
    creditorName: basicSearchPayload?.creditorName, 
    creditorId: basicSearchPayload?.creditorId, 
    claimId: basicSearchPayload?.claimId, 
    debtorName: basicSearchPayload?.debtorName, 
    country: basicSearchPayload?.country, 
    province: basicSearchPayload?.province, 
    postalCode: basicSearchPayload?.postalCode, 
    phoneNumber: basicSearchPayload?.phoneNumber, 
    claimUpdateDate: basicSearchPayload?.claimUpdateDate
  });

  useEffect(() => {
    setState({
      creditorName: basicSearchPayload?.creditorName, 
      creditorId: basicSearchPayload?.creditorId, 
      claimId: basicSearchPayload?.claimId, 
      debtorName: basicSearchPayload?.debtorName, 
      country: basicSearchPayload?.country, 
      province: basicSearchPayload?.province, 
      postalCode: basicSearchPayload?.postalCode, 
      phoneNumber: basicSearchPayload?.phoneNumber, 
      claimUpdateDate: basicSearchPayload?.claimUpdateDate
    });
  }, [basicSearchPayload?.claimId, basicSearchPayload?.claimUpdateDate, basicSearchPayload?.country, basicSearchPayload?.creditorId, basicSearchPayload?.creditorName, basicSearchPayload?.debtorName, basicSearchPayload?.phoneNumber, basicSearchPayload?.postalCode, basicSearchPayload?.province, showBasicSearch]);

  const [countryId, setCountryId] = useState(basicSearchPayload?.country || "");
  const countryList = useSelector((state: any) => state.country.countryList);
  const { data: stateList, isLoading: stateLoader } =
    useGetStateByCountryIdQuery(countryId, { skip: !countryId });
  const [countryArray, setCountryArry] = useState([]);
  const [stateArray, setStateArry] = useState([]);
  useEffect(() => {
    if (countryList !== undefined) {
      setCountryArry(countryList || []);
    }
  }, [countryList]);
  useEffect(() => {
    if (stateList !== undefined) {
      setStateArry(stateList || []);
    }
  }, [stateArray,stateLoader,stateList]);
 
  const countryPlaceHolder = countryArray.filter((option:any) => {
    return option.countryId === state.country;
  });

  const statePlaceHolder = stateArray.filter((option:any) => {
    //@ts-ignore
    return option.id === state.province;
  });

  return (
    <div className="claims-basic-search-container">
      <div className="motif-row">
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.creditorName")}</MotifLabel>
          <MotifFormField>
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => {
                  handleChange("creditorName", e.target.value)
                  setState({...state, creditorName: e.target.value})
                }
              }
              value={state.creditorName}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.creditorId")}</MotifLabel>
          <MotifFormField>
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => { handleChange("creditorId", e.target.value)
              setState({...state, creditorId: e.target.value})
              }}
              value={state.creditorId}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.claimId")}</MotifLabel>
          <MotifFormField>
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => {handleChange("claimId", e.target.value)
              setState({...state, claimId: e.target.value})
              }}
              value={state.claimId}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.debtorName")}</MotifLabel>
          <MotifFormField>
            {/*@ts-ignore */}
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => {handleChange("debtorName", e.target.value)
              setState({...state, debtorName: e.target.value})
              }}
              value={state.debtorName}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.country")} </MotifLabel>
          <MotifFormField>
            {/*@ts-ignore */}

            {/* <MotifInput
              @ts-ignore
              onChange={(e: any) => handleChange("country", e.target.value)}
              value={country}
              hideClearButton={true}
            /> */}
            <MotifSelect
              onChange={(value) => {
                setCountryId(value);
                handleChange("country", value);
                setState({...state, country: value})
              }}
              value={state.country}
              visibleOptions={3}
              //@ts-ignore
              placeholder={countryPlaceHolder[0]?.countryName || t("global.globalPlaceholder.countryPlaceholder")}
              filter={true}
            >
              {countryArray.map((option: any) => (
                <MotifOption value={option.countryId}>
                  {option.countryName}
                </MotifOption>
              ))}
            </MotifSelect>
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.provinceState")} </MotifLabel>
          <MotifFormField>
            {/*@ts-ignore */}
            {/* <MotifInput
              /*@ts-ignore
              onChange={(e: any) => handleChange("province", e.target.value)}
              value={province}
              hideClearButton={true}
            /> */}
            <MotifSelect
              onChange={(value) => {
                handleChange("province", value);
                setState({...state, province: value})
              }}
              value={state.province}
              visibleOptions={3}
              //@ts-ignore
              placeholder={statePlaceHolder[0]?.name || t("global.globalPlaceholder.statePlaceholder")}
              filter={true}
            >
              {stateArray.map((option: any) => (
                <MotifOption value={option.id}>{option.name}</MotifOption>
              ))}
            </MotifSelect>
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.postalCode")} </MotifLabel>
          <MotifFormField>
            {/*@ts-ignore */}
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => {handleChange("postalCode", e.target.value)
              setState({...state, postalCode: e.target.value})
              }}
              value={state.postalCode}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.phoneNumber")} </MotifLabel>
          <MotifFormField>
            {/*@ts-ignore */}
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => {handleChange("phoneNumber", e.target.value)
              setState({...state, phoneNumber: e.target.value})
              }}
              value={state.phoneNumber}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.creditors.creditorBasicSearch.claimUpdatedDate")}</MotifLabel>
          <MotifFormField>
            <FormattedDatePicker
              todayMark={true}
              range={false}
              onChange={(value) => {handleChange("claimUpdateDate", value)
              setState({...state, claimUpdateDate: value})
              }}
              value={state.claimUpdateDate}
            />
          </MotifFormField>
        </div>
        <div className="basic-search-buttons">
          <MotifButton
            size="small"
            type="button"
            variant={CANCEL_BUTTON_VARIANT}
            onClick={() => setShowBasicSearch(false)}
          >
            {t("global.globalActions.cancel")}
          </MotifButton>

          <MotifButton
            size="small"
            variant={APPLY_BUTTON_VARIANT}
            onClick={() => {
              setShowBasicSearch(false);
              handleSubmit();
            }}
          >
                        {t("global.globalActions.apply")}

          </MotifButton>
        </div>
      </div>
    </div>
  );
};
